import { BillingPeriod } from "@redotech/redo-model/billing/service-invoice";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export type ImsForecastingInvoiceStatus = z.infer<
  typeof imsForecastingInvoiceStatus
>;
export const imsForecastingInvoiceStatus = z.object({
  period: createEnum(BillingPeriod),
  subscriptionPrice: z.number(),
  billingDueDate: z.date(),
  totalInvoiceAmount: z.number(),
});

export const getCurrentImsForecastingInvoice = {
  name: "getCurrentImsForecastingInvoice" as const,
  input: z.null(),
  output: imsForecastingInvoiceStatus.nullable(),
};
